import type { CloudMarketplace, Product } from '../../productsListing/types'
import { FlyoutFunction } from '../../productsListing/types'
import { isResaleProduct } from '../../../utils/privateOfferOrResaleHelperFunctions'
import { notAllowedProductSelection } from '../types'
import { getProductFilterListData } from './getProductFilterListData'

export const getFlyoutProductsListBasedOnFunction = (
  products: Product[],
  functionType: FlyoutFunction,
  cloudMarketplace: CloudMarketplace
) => {
  const filteredProduct = products?.filter(
    productItem =>
      !(
        productItem?.cloudMarketplace === 'AWS' &&
        productItem.productType &&
        notAllowedProductSelection.includes(productItem?.status)
      )
  )
  switch (functionType) {
    case FlyoutFunction.REVENUE:
    case FlyoutFunction.PRIVATE_OFFERS: {
      return getProductFilterListData(filteredProduct)
    }
    case FlyoutFunction.RESALE_AUTHORIZATIONS: {
      if (cloudMarketplace === 'AWS') {
        return getProductFilterListData(
          filteredProduct.filter(product => isResaleProduct(product))
        )
      }
      return getProductFilterListData(filteredProduct)
    }
    case FlyoutFunction.SUBSCRIPTION: {
      return getProductFilterListData(filteredProduct)
    }
    default: {
      return []
    }
  }
}
